
import commManager from "./commManager"


if(window.cmanager === undefined){
	window.cmanager = new commManager();
}


var requestData = (path, method = "GET", obj={}, customHeaders = null, responseTimeoutSeconds = 15)=>{
	console.log("path", path, method, customHeaders);
	if(window.cmanager){
		console.log('path, method, obj, customHeaders, responseTimeoutSeconds', path, method, obj, customHeaders, responseTimeoutSeconds);
		console.log('pravi timeout', (path && (path.includes("playScene") || path.includes("stopScene"))) ? 300 : responseTimeoutSeconds);
		
		return window.cmanager.requestFromSlave(path, method, obj, customHeaders, ((path && (path.includes("playScene") || path.includes("stopScene"))) ? 300 : responseTimeoutSeconds));
	} else {
		throw new Error("Calling request before initLoaders!");
	}
}

var requestDataLongTimeout = (path, method, obj, customHeaders, timeoutLength = 300)=>{
	return requestData(path, method, obj, customHeaders, timeoutLength);
}


export default window.cmanager

export {requestData, requestDataLongTimeout}